<template>
  <result
    :isSuccess="true"
    :content="false"
    title="提交成功"
    :description="description">

    <template slot="action">
      <a-button size="large" style="margin-left: 8px" @click="goHomeHandle">返回首页</a-button>
    </template>

  </result>
</template>

<script>
  import { Result } from '@/components'

  export default {
    name: 'RegisterResult',
    components: {
      Result
    },
    data () {
      return {
        description: '账号创建已提交审核，审核结果会以短信形式通知，请注意查收！',
        form: {}
      }
    },
    computed: {
      // email () {
      //   const v = this.form && this.form.email || 'xxx'
      //   const title = `你的账户：${v} 注册成功`
      //   return title
      // }
    },
    created () {
      this.form = this.$route.params
    },
    methods: {
      goHomeHandle () {
        this.$router.push({ name: 'login' })
      }
    }
  }
</script>

<style scoped>

</style>